<template>
  <RouterView />
</template>

<script setup>
// Le layout est géré par withGeneralLayout dans routesConfig.ts
</script>

<style>
/* Style global, optionnel */
</style>
